import React from "react";
import { useFeatureEntitlements } from "@frontegg/react";
import AstradaLinkedAccounts from "components/admin/linkedAccounts/AstradaLinkedAccounts";
import { astradaMocksEnabled } from "components/admin/linkedAccounts/mockAstradaData";
import PlaidLinkedAccounts from "components/admin/linkedAccounts/PlaidLinkedAccounts";

/**
 * Provider switch for /admin/settings/linked-accounts, and the only file that reads the flag.
 *
 * See client/src/components/admin/linkedAccounts/README.md.
 */
const LinkedAccounts: React.FC = () => {
  const { isEntitled: featureAstrada } =
    useFeatureEntitlements("feature_astrada");

  // The mock flag also opens the Astrada branch so the screen is reachable locally without
  // feature_astrada entitled. Goes away with the mock module; see the README checklist.
  if (!featureAstrada && !astradaMocksEnabled()) {
    return <PlaidLinkedAccounts />;
  }

  return <AstradaLinkedAccounts />;
};

export default LinkedAccounts;
